import { safeFetch } from "@/api/safeFetch";
import { fixImageOrientation } from "@/components/utils/fixImageOrientation";

/* Funcion para subir imagen fondo */

export const uploadBackgroundLanding = async (file: File, perfilId: number) => {
  const fixedFile = await fixImageOrientation(file);

  const formData = new FormData();
  formData.append("file", fixedFile);

  const res = await safeFetch(`/api/udloaderLanding/${perfilId}/upload/fondo`, {
    method: "POST",
    body: formData,
  });

  if (!res.ok) {
    const text = await res.text();
    console.error(text);
    throw new Error("Error subiendo fondo");
  }

  return await res.json(); // { ok, url }
};

/* ============================================================
   UPDATE WHO WE ARE (CLEAN VERSION)
============================================================ */
export const updateWhoWeAre = async (perfilId: number, data: any) => {
  // 🔥 CLEAN: evita blobs en DB
  const cleanWhoWeAre = {
    ...data,
    sliderImages: (data.sliderImages || []).filter(
      (i: string) => typeof i === "string" && !i.startsWith("blob:"),
    ),
    team: (data.team || []).map((t: any) => ({
      ...t,
      foto:
        typeof t.foto === "string" && t.foto.startsWith("blob:") ? "" : t.foto,
    })),
  };

  const res = await safeFetch(`/api/landing/${perfilId}/who-we-are`, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(cleanWhoWeAre),
  });

  if (!res.ok) {
    const text = await res.text();
    console.error("UPDATE WHO WE ARE ERROR:", text);
    throw new Error("Error actualizando who_we_are");
  }

  return await res.json();
};

/* ============================================================
   SUBIR IMAGEN SLIDER LANDING
============================================================ */
export const subirImagenSliderLanding = async (
  file: File,
  perfilProfesionalId: number,
) => {
  const fixedFile = await fixImageOrientation(file);

  const formData = new FormData();
  formData.append("file", fixedFile);

  const res = await safeFetch(
    `/api/udloaderLanding/${perfilProfesionalId}/upload/slider`,
    {
      method: "POST",
      body: formData,
    },
  );

  if (!res.ok) {
    const text = await res.text();
    console.error("UPLOAD SLIDER ERROR:", text);
    throw new Error("Error subiendo imagen slider");
  }

  const data = await res.json();

  // SOLO devolver data (no estado aquí)
  return data; // { url }
};

/* ============================================================
   SUBIR FOTO EQUIPO LANDING
============================================================ */
export const subirImagenEquipoLanding = async (
  file: File,
  perfilProfesionalId: number,
) => {
  const fixedFile = await fixImageOrientation(file);

  const formData = new FormData();
  formData.append("file", fixedFile);

  const res = await safeFetch(
    `/api/udloaderLanding/${perfilProfesionalId}/upload/team`,
    {
      method: "POST",
      body: formData,
    },
  );

  if (!res.ok) {
    const text = await res.text();
    console.error("UPLOAD TEAM ERROR:", text);
    throw new Error("Error subiendo imagen equipo");
  }

  const data = await res.json();

  // SOLO devolver URL
  return data; // { url }
};

/* ============================================================
   SUBIR FOTOS OFERTAS LANDING
============================================================ */

export const subirImagenOfertaLanding = async (
  file: File,
  perfilId: number,
  ofertaId: string,
) => {
  const fixedFile = await fixImageOrientation(file);

  const formData = new FormData();
  formData.append("file", fixedFile);

  const res = await safeFetch(
    `/api/udloaderLanding/${perfilId}/ofertas/${ofertaId}/upload`,
    {
      method: "POST",
      body: formData,
    },
  );

  if (!res.ok) {
    const text = await res.text();
    console.error("UPLOAD OFERTA ERROR:", text);
    throw new Error("Error subiendo imagen oferta");
  }

  return res.json();
};

/* ============================================================
   BORRAR FOTOS  LANDING
============================================================ */

export const deleteOfertaLanding = async (
  ofertaId: string,
): Promise<{ ok: boolean; images: string[] }> => {
  const res = await safeFetch(`/api/udloaderLanding/ofertas/${ofertaId}`, {
    method: "DELETE",
    credentials: "include",
  });

  if (!res.ok) {
    throw new Error("Error eliminando oferta");
  }

  return res.json();
};

export const uploadEmpleoImage = async (file: File, perfilId: number) => {
  const fixedFile = await fixImageOrientation(file);

  const formData = new FormData();
  formData.append("file", fixedFile);

  const res = await safeFetch(
    `/api/udloaderLanding/${perfilId}/empleos/upload`,
    {
      method: "POST",
      body: formData,
    },
  );

  if (!res.ok) {
    const text = await res.text();
    console.error("UPLOAD EMPLEO ERROR:", text);
    throw new Error("Error subiendo imagen empleo");
  }

  return await res.json(); // { ok, url }
};
